import CButton from "components/CButton";
import CDialog from "components/CDialog";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useTracker from "components/CTracker/useTrackerContext";

const InitialOfferVerification: React.FC = () => {
  const { loan } = useTracker();
  const navigate = useNavigate();
  const [showDifferentOfferWarning, setShowDifferentOfferWarning] =
    useState(false);

  useEffect(() => {
    if (
      loan &&
      loan.initialOffer.offerOutdated &&
      !loan.finalOffer &&
      !loan?.borrowerFlags?.initialOfferOutdatedAccepted
    ) {
      setShowDifferentOfferWarning(true);
    }
  }, [
    loan,
    loan?.initialOffer?.offerOutdated,
    loan?.borrowerFlags?.initialOfferOutdatedAccepted,
  ]);

  return (
    <CDialog
      fullWidth
      maxWidth="xs"
      icon="warning"
      scroll={"paper"}
      sx={{ padding: "2rem" }}
      title="Your offer has changed."
      open={showDifferentOfferWarning}
      description={"Your offer expired, we have a new one for you."}
      onClose={() => setShowDifferentOfferWarning(false)}
    >
      <CButton
        fullWidth
        onClick={() => navigate("/initial-offer")}
        variant="contained"
      >
        View new offer
      </CButton>
    </CDialog>
  );
};

export default InitialOfferVerification;
